// extracted by mini-css-extract-plugin
export default {"wrapper":"ErrorPage_wrapper__Lf8Fc","titleWrapper":"ErrorPage_titleWrapper__LMFAy","title":"ErrorPage_title__eBr1e","subtitle":"ErrorPage_subtitle__LKGTB"};